import { useMemo } from 'react';
import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import {
  useCreateProduct,
  useGetNonLocalizedProductFields,
} from 'api/productApi';
import ProductForm from './components/ProductForm';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useCustomSearchParams } from 'hooks/useCustomSearchParams';
import _ from 'lodash';
import { PATH_NAME } from '../../constants/routes';

export default function AddProduct() {
  const intl = useIntl();
  const createMutation = useCreateProduct();

  const navigate = useNavigate();
  const [search] = useCustomSearchParams();
  const { relatedEntityId, ...defaultInitialValues } = useMemo(() => {
    return {
      locale: _.get(search, ['locale_code']),
      relatedEntityId: _.get(search, ['related_entity_id']),
      published: true,
    };
  }, [search]);
  const { data: localizations, isLoading: isLoadingLocalizations } =
    useGetNonLocalizedProductFields({
      id: relatedEntityId,
      options: {
        enabled: !!relatedEntityId,
      },
    });

  const handleSubmit = (values) => {
    createMutation.mutate(values, {
      onSuccess(response) {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.createSuccess`,
          }),
        );

        navigate(`/${PATH_NAME.PRODUCTS}/${response.id}`);
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoadingLocalizations) {
    return null;
  }

  return (
    <ContentWrapper title="Tạo mới">
      <ProductForm
        onSubmit={handleSubmit}
        isLoading={createMutation.isLoading}
        relatedEntityId={relatedEntityId}
        initialValues={defaultInitialValues}
        localizations={localizations}
      />
    </ContentWrapper>
  );
}
